package com.yogaaicoach.pages.dashboard

import Config
import com.yogaaicoach.common.network.ApiClient
import io.ktor.http.HttpMethod

class DashboardApi(private val client: ApiClient) {
    suspend fun getDashboardData(): DashboardData? {
        return client.makeRequest(
            url = "${Config.API_URL}/dashboardData",
            method = HttpMethod.Get,
        )
    }
}
